const Table = ({ children }) => <table className="table-line-items table-borderless mb-4">{children}</table>

export default Table
